export const safeJsonParse = <T = any>(
  str?: string,
  defaultValue: any = {},
): T => {
  if (!str) return defaultValue as T;
  try {
    return JSON.parse(str) || defaultValue;
  } catch (error) {
    return defaultValue as T;
  }
};

export const safeJsonStringify = <T = any>(
  obj?: T,
  defaultValue: any = {},
): string => {
  if (!obj) return defaultValue as string;
  try {
    return JSON.stringify(obj) || defaultValue;
  } catch (error) {
    return defaultValue as string;
  }
};

export function cleanProcessText(text: string): string {
  if (!text) return "";
  return text
    .replace(/\/\*(PLANNING|REPLANNING|REASONING|ACTION|FINAL_ANSWER)\*\//g, "")
    .trim();
}

// 导出新的解析工具
export * from './parseAgentMessage';
export * from './markdownResource';
